import { Layer } from "effect";
import { AddToCartEvents } from "./AddToCartEvents";
import { extendRuntime } from "../Runtime";

export const CartRuntime = extendRuntime(Layer.mergeAll(AddToCartEvents.Live));
